export function getSessionId() {
  const currentSesionId = sessionStorage.getItem("session_id")
  if (!currentSesionId) {
    const newSesionId = Math.random().toString(36).slice(2, 7)
    sessionStorage.setItem("session_id", newSesionId)
    return newSesionId
  }
  return currentSesionId
}
